import { NgModule } from '@angular/core';

import { PushPipe } from '@ngrx/component';

import { ExcludedCalculationsModule } from '@cdba/shared/components/excluded-calculations';
import { InViewModule } from '@cdba/shared/directives/in-view';

import { UserInteractionDialogComponent } from '../../../../../user-interaction/dialog/user-interaction-dialog.component';
import { CompareButtonModule } from '../../button/compare-button';
import { LoadBomButtonComponent } from '../../button/load-bom-button/load-bom-button.component';
import { CalculationsStatusBarComponent } from './calculations-status-bar.component';

@NgModule({
  declarations: [CalculationsStatusBarComponent],
  imports: [
    PushPipe,
    InViewModule,
    LoadBomButtonComponent,
    CompareButtonModule,
    ExcludedCalculationsModule,
    UserInteractionDialogComponent,
  ],
  exports: [CalculationsStatusBarComponent],
})
export class CalculationsStatusBarModule {}
